import axios from "axios";
import { AssignmentCreationDTO, AssignmentDTO, assignmentLetterTypeEnum, AssignmentUpdateDTO, GetAllAssignmentDTO, GetAllAssignmentFiltersDTO, GetAllInspectionVisitDTO, GetAllInspectionVisitFiltersDTO, GetAllResultControlActivityDTO, GetAllResultControlActivityFiltersDTO, InspectionVisitCreationDTO, InspectionVisitDTO, InspectionVisitTurnOverFiltersDTO, InspectionVisitUpdateDTO, ResultControlActivityCreationDTO, ResultControlActivityDTO, ResultControlActivityUpdateDTO, TurnOverResponseDTO } from "./dto";
import { AssignmentService } from "./service";
import { keycloak } from "../../../lib/keycloak";
import { downloadFileFromResponse } from "../../../utils/download";

export class AssignmentServiceImpl implements AssignmentService {

    public CreateAssignment(data: AssignmentCreationDTO): Promise<string> {
        return axios.post("/api/assignment",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DownloadAssignmentLetter(data: { id: string, infoType: assignmentLetterTypeEnum }): Promise<void> {
        return axios.get(`/api/download/assignment-letter-docx/${data.id}`, {
            params: {
                assignmentLetterType: data.infoType
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            },
            responseType: 'text',
        }).then((response) => {
            downloadFileFromResponse(response.data, 'Lettera incarico test.docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
        }).catch((error) => {
            console.error('Errore durante il download del file:', error);
        });
    }

    // public DownloadAssignmentLetter(data: { id: string, infoType: assignmentLetterTypeEnum }): Promise<void> {
    //     return axios.get(`/api/download/assignment-letter-docx/${data.id}`, {
    //         params: {
    //             assignmentLetterType: data.infoType
    //         },
    //         headers: {
    //             Authorization: 'Bearer ' + keycloak.token,
    //             Accept: '*/*',
    //             ContentType: 'application/json',
    //             "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
    //             "Access-Control-Allow-Origin": "http://localhost:3000",
    //             "Access-Control-Allow-Methods": "GET",
    //         }

    //     }).then((response) => {
    //         const base64String = response.data.slice(1, -1);
    //         // Decode Base64
    //         const byteCharacters = atob(base64String);
    //         const byteNumbers = new Array(byteCharacters.length);
    //         for (let i = 0; i < byteCharacters.length; i++) {
    //             byteNumbers[i] = byteCharacters.charCodeAt(i);
    //         }
    //         const byteArray = new Uint8Array(byteNumbers);

    //         // Create blob with binary
    //         const blob = new Blob([byteArray], {
    //             type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    //         });

    //         // tmp url
    //         const url = URL.createObjectURL(blob);

    //         //link trigger download
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.setAttribute('download', `Lettera_Incarico` + '.docx');
    //         document.body.appendChild(link);
    //         link.click();

    //         // remove link
    //         document.body.removeChild(link);

    //         // empty memory
    //         URL.revokeObjectURL(url);
    //     }).catch((error) => {
    //         console.error('Errore durante il download del file:', error);
    //     });
    // }

    public UpdateAssignment(data: AssignmentUpdateDTO, id: string): Promise<void> {
        return axios.put("/api/assignment/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteAssignment(id: string): Promise<void> {
        return axios.delete("/api/assignment/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllAssignment(filters: GetAllAssignmentFiltersDTO): Promise<GetAllAssignmentDTO> {
        return axios.get("/api/assignment", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                year: filters.year,
                inspectorCode: filters.inspectorCode,
                reference: filters.reference
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetAssignmentById(id: string): Promise<AssignmentDTO> {
        return axios.get("/api/assignment/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public InspectionVisitTurnOver(inspectorCode: string, customerId: string): Promise<TurnOverResponseDTO>{
        return axios.get("/api/inspection-visit/turn-over-control/"+inspectorCode+"/"+customerId, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public UploadFileAssSigned(body: FormData, id: string): Promise<void> {
        return axios.put("/api/assignment/upload-file/"+id,
            body,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then((response) => response.data);
    }

    public CreateInspectionVisit(data: InspectionVisitCreationDTO): Promise<void> {
        return axios.post("/api/inspection-visit",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateInspectionVisit(data: InspectionVisitUpdateDTO, id: string): Promise<void> {
        return axios.put("/api/inspection-visit/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteInspectionVisit(id: string): Promise<void> {
        return axios.delete("/api/inspection-visit/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllInspectionVisit(filters: GetAllInspectionVisitFiltersDTO): Promise<GetAllInspectionVisitDTO> {
        return axios.get("/api/inspection-visit", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                year: filters.year,
                assignmentId: filters.assignmentId,
                customerId: filters.customerId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetInspectionVisitById(id: string): Promise<InspectionVisitDTO> {
        return axios.get("/api/inspection-visit/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public InspectionVisitUploadFile(data: FormData, id: string): Promise<string> {
        return axios.put("/api/inspection-visit/upload-file/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then((response) => response.data);
    }

    public CreateResultControlActivity(data: ResultControlActivityCreationDTO): Promise<void> {
        return axios.post("/api/result-control-activity",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateResultControlActivity(data: ResultControlActivityUpdateDTO, id: string): Promise<void> {
        return axios.put("/api/result-control-activity/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteResultControlActivity(id: string): Promise<void> {
        return axios.delete("/api/result-control-activity/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllResultControlActivity(filters: GetAllResultControlActivityFiltersDTO): Promise<GetAllResultControlActivityDTO> {
        return axios.get("/api/result-control-activity", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                year: filters.year,
                inspectionVisitId: filters.inspectionVisitId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetResultControlActivityById(id: string): Promise<ResultControlActivityDTO> {
        return axios.get("/api/result-control-activity/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}